// import { getOrder } from "@/api/module/tenant";
import Store from "../index";
import { setWsMsgData, getSameValue, checkLeftGateTab, checkParkInGateTab } from "@/utils/wsMsg";

const order = {
  state: {
    showOrderDetail: false,
    parkLotId: "",
    gateId: "",
    gateIds: [],
    wsOrderArrStr: '',
    payOrderGateId: null,
    pubOutGateId: '',
    showAuthCode: false,
    gateIdsStr: '',
    gateIdsSortStr: '',
    noticeSortStr: '',
    autoCompleteSelect: undefined,
    moreWsData: {},
    moreWsDataStr: '',
    moreBlackParkIn: {},
    moreBlackParkInStr: '',
    blackMsgArrStr: '',
    videoGateIds: undefined,
    liveImages: '{}',
    deviceStatusMsg: [],
    deviceStatusMsgStr: '',
    tabsGateId: undefined,
    leftGateIdTabs: '',
    inGateIdTabs: '',
  },
  mutations: {
    SET_SHOWORDERDETAIL: (state, bool) => {
      state.showOrderDetail = bool;
    },
    SET_PARKLOTID: (state, parkLotId) => {
      state.parkLotId = parkLotId;
    },
    SET_GATEID: (state, gateId) => {
      state.gateId = gateId;
    },
    SET_GATEIDS: (state, gateIds) => {
      state.gateIds = gateIds;
    },
    SET_WSORDERARRSTR: (state, wsOrderArrStr) => {
      state.wsOrderArrStr = wsOrderArrStr;
    },
    SET_ShowAuthCode: (state, showAuthCode) => {
      state.showAuthCode = showAuthCode;
    },
    SET_PayOrderGateId: (state, payOrderGateId) => {
      state.payOrderGateId = payOrderGateId;
    },
    SET_PubOutGateId: (state, pubOutGateId) => {
      state.pubOutGateId = pubOutGateId;
    },
    SET_GateIdsStr: (state, gateIdsStr) => {
      state.gateIdsStr = gateIdsStr;
    },
    SET_GateIdsSortStr: (state, gateIdsSortStr) => {
      state.gateIdsSortStr = gateIdsSortStr;
    },
    SET_NoticeSortStr: (state, noticeSortStr) => {
      state.noticeSortStr = noticeSortStr;
    },
    SET_AutoCompleteSelect: (state, autoCompleteSelect) => {
      state.autoCompleteSelect = autoCompleteSelect;
    },
    SET_MoreWsData: (state, moreWsData) => {
      state.moreWsData = moreWsData;
    },
    SET_MoreWsDataStr: (state, moreWsDataStr) => {
      state.moreWsDataStr = moreWsDataStr;
    },
    SET_MoreBlackParkIn: (state, moreBlackParkIn) => {
      state.moreBlackParkIn = moreBlackParkIn;
    },
    SET_MoreBlackParkInStr: (state, moreBlackParkInStr) => {
      state.moreBlackParkInStr = moreBlackParkInStr;
    },
    SET_BlackMsgArrStr: (state, blackMsgArrStr) => {
      state.blackMsgArrStr = blackMsgArrStr;
    },
    SET_VideoGateIds: (state, videoGateIds) => {
      state.videoGateIds = videoGateIds;
    },
    SET_LiveImages: (state, liveImages) => {
      state.liveImages = liveImages;
    },
    SET_DeviceStatusMsg: (state, deviceStatusMsg) => {
      state.deviceStatusMsg = deviceStatusMsg;
    },
    SET_DeviceStatusMsgStr: (state, deviceStatusMsgStr) => {
      state.deviceStatusMsgStr = deviceStatusMsgStr;
    },
    SET_TabsGateId: (state, tabsGateId) => {
      state.tabsGateId = tabsGateId;
    },
    SET_LeftGateIdTabs: (state, leftGateIdTabs) => {
      // sessionStorage.setItem('leftGateIdTabs', JSON.stringify(leftGateIdTabs));
      state.leftGateIdTabs = leftGateIdTabs;
    },
    SET_InGateIdTabs: (state, inGateIdTabs) => {
      // sessionStorage.setItem('inGateIdTabs', JSON.stringify(inGateIdTabs));
      state.inGateIdTabs = inGateIdTabs;
    },
  },
  actions: {
    GetShowOrderDetail({ commit }, bool) {
      commit("SET_SHOWORDERDETAIL", bool);
    },
    SetParkLotId({ commit }, parkLotId) {
      commit("SET_PARKLOTID", parkLotId);
    },
    SetGateId({ commit }, gateId) {
      commit("SET_GATEID", gateId);
    },
    SetGateIds({ commit }, gateIds) {
      let leftArr = gateIds.filter((item) => {
        return Number(item.Direction) === 2;
      }).map(v => {
        v.hidden = true;
        return v
      });
      let inArr = gateIds.filter((item) => {
        return Number(item.Direction) === 1;
      }).map(v => {
        v.hidden = true;
        return v
      });
      commit("SET_LeftGateIdTabs", JSON.stringify(leftArr));
      commit("SET_InGateIdTabs", JSON.stringify(inArr));
      checkLeftGateTab();
      checkParkInGateTab();
      // console.log('SetGateIds', Store.state.order.leftGateIdTabs, inArr);
      commit("SET_GATEIDS", gateIds);
    },
    SetShowAuthCode({ commit }, showAuthCode) {
      commit("SET_ShowAuthCode", showAuthCode);
    },
    SetPayOrderGateId({ commit }, payOrderGateId) {
      sessionStorage.setItem('OutGateId', payOrderGateId);
      commit("SET_PayOrderGateId", payOrderGateId);
    },
    SetPubOutGateId({ commit }, pubOutGateId) {
      commit("SET_PubOutGateId", pubOutGateId);
    },
    SETGateIdsStr({ commit }, gateIdsStr) {
      commit("SET_GateIdsStr", gateIdsStr);
    },
    SETGateIdsSortStr({ commit }, gateIdsSortStr) {
      commit("SET_GateIdsSortStr", gateIdsSortStr);
    },
    SETNoticeSortStr({ commit }, noticeSortStr) {
      commit("SET_NoticeSortStr", noticeSortStr);
    },
    SETAutoCompleteSelect({ commit }, autoCompleteSelect) {
      commit("SET_AutoCompleteSelect", autoCompleteSelect);
    },
    SETMoreWsData({ commit }, MoreWsData) {
      let {obj, SentryBoxId} = MoreWsData;
      // console.log(obj, SentryBoxId)
      if (!SentryBoxId) {
        return false;
      }
      let moreWsData = setWsMsgData(obj, SentryBoxId, 'moreWsData');
      let sameIdArr = getSameValue(SentryBoxId, moreWsData, obj, 'plate_number');
      // console.log(sameIdArr);
      let sameGateIdArr = getSameValue(SentryBoxId, moreWsData, obj, 'park_lot_gate_id');
      if (sameIdArr.length === 0 && obj.message_type && (obj.message_type === '2' || obj.message_type === '5')) {
        if (sameGateIdArr.length === 0) {
          moreWsData[SentryBoxId].unshift(obj)
        } else {
          moreWsData[SentryBoxId][moreWsData[SentryBoxId].indexOf(sameGateIdArr[0])] = obj
        }
      } else if (sameIdArr.length > 0 && (sameIdArr[0].message_type === '2' && obj.message_type === '5' || sameIdArr[0].message_type === '5' && obj.message_type === '2')) {
        let index = moreWsData[SentryBoxId].indexOf(sameIdArr[0]);
        moreWsData[SentryBoxId].splice(index, 1);
        // console.log(moreWsData[SentryBoxId])
      }
      moreWsData.lastKey = parseInt(sessionStorage.getItem('sentryId'));
      // console.log(moreWsData[SentryBoxId], Store.state.order.leftGateIdTabs)
      if (moreWsData[SentryBoxId].length > 0) {
        checkLeftGateTab(moreWsData[SentryBoxId]);
      } else if (moreWsData[SentryBoxId].length === 0 && Store.state.order.leftGateIdTabs !== '' && Store.state.order.leftGateIdTabs !== '[]') {
        checkLeftGateTab([]);
      }
      sessionStorage.setItem('moreWsData', JSON.stringify(moreWsData));
      commit("SET_WSORDERARRSTR", JSON.stringify(moreWsData[SentryBoxId]));
      commit("SET_MoreWsData", moreWsData);
      commit("SET_MoreWsDataStr", JSON.stringify(moreWsData));
      // let nowTimeNode = new Date().getTime();
      // let lastTimeNode = parseInt(sessionStorage.getItem('lastRefreshTimeNode'));
      // let keysArr = Object.keys(moreWsData);
      // keysArr.pop();
      // let orderLength = 0;
      // keysArr.forEach(v => {
      //   orderLength += moreWsData[v].length;
      // });
      // if (nowTimeNode - lastTimeNode > 6 * 60 * 60 * 1000 && orderLength === 0) {
      //   setTimeout(() => {
      //     sessionStorage.setItem('lastRefreshTimeNode', nowTimeNode);
      //     location.reload();
      //   }, 10000)
      // }
    },
    SETMoreBlackParkIn({ commit }, MoreBlackParkIn) {
      let {obj, SentryBoxId, key} = MoreBlackParkIn;
      if (!SentryBoxId) {
        return false;
      }
      let moreBlackParkIn = setWsMsgData(obj, SentryBoxId, 'moreBlackParkIn');
      // console.log(obj, SentryBoxId, key, moreBlackParkIn)
      let samePlateArr = getSameValue(SentryBoxId, moreBlackParkIn, obj, 'plate_number');
      let sameGateIdArr =  getSameValue(SentryBoxId, moreBlackParkIn, obj, 'park_lot_gate_id');
      // console.log(samePlateArr, sameGateIdArr)
      if (obj.SentryId) {
        if (obj.message_type && obj.message_type !== '5' && obj.message_type !== '32') {
          if (samePlateArr.length === 0 && sameGateIdArr.length === 0) {
            moreBlackParkIn[obj.SentryId].push(obj)
          } else if (sameGateIdArr.length > 0 && samePlateArr.length === 0){
            moreBlackParkIn[obj.SentryId][moreBlackParkIn[obj.SentryId].indexOf(sameGateIdArr[0])] = obj
          } else if (sameGateIdArr.length === 0 && samePlateArr.length > 0) {
            moreBlackParkIn[obj.SentryId][moreBlackParkIn[obj.SentryId].indexOf(samePlateArr[0])] = obj
          }
        }
        if (key === 'update' || obj.message_type === '5' || obj.message_type === '32') {
          let index = moreBlackParkIn[obj.SentryId].indexOf(samePlateArr[0]);
          if (samePlateArr.length > 0 && index > -1) {
            // console.log(index)
            moreBlackParkIn[obj.SentryId][index] = obj;
            setTimeout(() => {
              moreBlackParkIn[obj.SentryId].splice(index, 1);
            }, 5000)
          } else {
            let index = moreBlackParkIn[obj.SentryId].indexOf(obj);
            moreBlackParkIn[obj.SentryId].splice(index, 1);
          }
        }
      }
      if (key === 'clear') {
        moreBlackParkIn[SentryBoxId] = []
      }
      // console.log(Store.state.order.inGateIdTabs)
      moreBlackParkIn.lastKey = parseInt(sessionStorage.getItem('sentryId'));
      if (Store.state.order.inGateIdTabs.length > 0)checkParkInGateTab();
      // console.log(moreBlackParkIn, SentryBoxId);
      sessionStorage.setItem('moreBlackParkIn', JSON.stringify(moreBlackParkIn));
      commit("SET_MoreBlackParkIn", moreBlackParkIn);
      commit("SET_MoreBlackParkInStr", JSON.stringify(moreBlackParkIn));
    },
    SetBlackMsgArrStr({ commit }, blackMsgArrStr) {
      commit("SET_BlackMsgArrStr", blackMsgArrStr);
    },
    SetVideoGateIds({ commit }, videoGateIds) {
      commit("SET_VideoGateIds", videoGateIds);
    },
    SetLiveImages({ commit }, liveImages) {
      commit("SET_LiveImages", liveImages);
    },
    SETDeviceStatusMsg({ commit }, deviceStatusMsg) {
      let {obj, key} = deviceStatusMsg;
      // console.log(obj, key)
      let storeDeviceStatusMsg = Store.state.order.deviceStatusMsg;
      if (obj.park_lot_id) {
        let sameArr = storeDeviceStatusMsg.filter(v => {
          return v.otherMsg === obj.otherMsg
        });
        if (sameArr.length === 0) storeDeviceStatusMsg.push(obj);
      }
      if (key === 'update') {
        let index = storeDeviceStatusMsg.indexOf(obj);
        storeDeviceStatusMsg.splice(index, 1);
      }
      // console.log(storeDeviceStatusMsg)
      sessionStorage.setItem('moreDeviceStatusMsg', JSON.stringify(storeDeviceStatusMsg));
      commit("SET_DeviceStatusMsg", storeDeviceStatusMsg);
      commit("SET_DeviceStatusMsgStr", JSON.stringify(storeDeviceStatusMsg));
    },
    SETDeviceStatusMsgStr({ commit }, deviceStatusMsg) {
      commit("SET_DeviceStatusMsg", deviceStatusMsg);
      commit("SET_DeviceStatusMsgStr", JSON.stringify(deviceStatusMsg));
    },
    SetTabsGateId({ commit }, tabsGateId) {
      commit("SET_TabsGateId", tabsGateId);
    },
    SetLeftGateIdTabs({ commit }, leftGateIdTabs) {
      commit("SET_LeftGateIdTabs", leftGateIdTabs);
    },
    SetInGateIdTabs({ commit }, inGateIdTabs) {
      commit("SET_InGateIdTabs", inGateIdTabs);
    },
  },
};

export default order;
